// Actions
const HANDLE_TAB_CHANGE = 'adminSettings/HANDLE_TAB_CHANGE';

const initialState = {
  selectedIndex: 0,
};

// Reducer
const reducer = (state = Object.assign({}, initialState), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case HANDLE_TAB_CHANGE:
      return { ...state, selectedIndex: payload };
    default: return state;
  }
};

// Action Creators
const handleTabChange = (payload) => {
  return { type: HANDLE_TAB_CHANGE, payload };
};


export default reducer;
export {
  // Actions
  HANDLE_TAB_CHANGE,
  // Action Creators
  handleTabChange,
};
